import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {Button, layout} from 'icsoc-antd-ex';
import UnionComponent from 'Components/union/unionComponent';
import tCallingNumberActions from 'Actions/systemSetting/callingNumber';
import {Form} from 'antd';
import TableList from './tableList';
import EditModal from './modal/editModal';

const FormItem = Form.Item;

const {BaseContentMainHeader} = layout;

class CallingNumber extends UnionComponent {
  constructor(props) {
    super(props);

    this.state = {
      tableListLoading: false,
      isEditModalVisible: false, // 编辑弹框是否可见
    };
  }

  componentWillMount() {
    const {actions} = this.props;

    actions.setPageStatus({pageNum: 1, pageSize: 20});
    // actions.getAdministrators();
  }

  // 设置编辑弹框显示隐藏
  setEditModalVisible = () => {
    const {isEditModalVisible} = this.state;
    const {actions} = this.props;

    this.setState(
      {
        isEditModalVisible: !isEditModalVisible,
      },
      () => {
        const {isEditModalVisible: currentIsEditModalVisible} = this.state;

        if (!currentIsEditModalVisible) {
          actions.setEditModalData({});
        }
      },
    );
  };

  render() {
    const {tableListLoading, isEditModalVisible} = this.state;
    const {login} = this.props;
    return (
      <React.Fragment>
          <div>
            <BaseContentMainHeader title="主叫号码">
              <Form layout="inline">
                {
                  login.permissionsList.includes('systemSettingCallingNumber.add') ?
                  <FormItem>
                    <Button type="success" onClick={this.setEditModalVisible}>
                      <span>添加主叫号码</span>
                    </Button>
                  </FormItem>
                : null}
              </Form>
            </BaseContentMainHeader>
            <TableList
              loading={tableListLoading}
              setTableListLoading={this.setTableListLoading}
              getTableList={this.getTableList}
              setEditModalVisible={this.setEditModalVisible}
            />
            {isEditModalVisible ? (
              <EditModal
                getTableList={this.getTableList}
                setEditModalVisible={this.setEditModalVisible}
              />
            ) : null}
          </div>
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({systemSettingCallingNumber,login}) => ({
  administrators: systemSettingCallingNumber.administrators,
  login
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tCallingNumberActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CallingNumber);
